/*
 * -----------------------------------------------------------------------
 * 2026.1.29---价格刺激营销测试---JS (PDP 与 Cart Drawer 分离 + 即时 Drawer 更新)
 * -----------------------------------------------------------------------
 */
(function () {
  // 阶梯（cents）
  const TIER_1 = 10000; // $100.00
  const TIER_2 = 40100; // $401.00
  const TIER_3 = 60100; // $601.00

  const root = document.getElementById('purchase-discount'); // PDP 容器（可不存在）
  const productPrice = root ? (parseInt(root.dataset.productPriceCents, 10) || 0) : 0;

  // 格式化为 "$1,234.56"（不附带 USD 后缀）
  function formatMoney(cents) {
    try {
      // 优先使用 Intl，保证输出为 $x,xxx.xx，不带 "USD"
      const dollars = cents / 100;
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(dollars);
    } catch (e) {
      return `$${(cents / 100).toFixed(2)}`;
    }
  }

  function getRate(total) {
    if (total >= TIER_3) return 0.12;
    if (total >= TIER_2) return 0.10;
    if (total >= TIER_1) return 0.08;
    return 0;
  }

  function getNextTier(total) {
    if (total < TIER_1) return { target: TIER_1, rate: 0.08 };
    if (total < TIER_2) return { target: TIER_2, rate: 0.10 };
    if (total < TIER_3) return { target: TIER_3, rate: 0.12 };
    return null;
  }

  // === PDP 渲染（只操作 PDP 的两个容器） ===
  function renderPDP(total, itemCount) {
    if (!root) return;
    const elCurrent = document.getElementById('pd-discount-current');
    const elNext = document.getElementById('pd-discount-next');
    if (!elCurrent || !elNext) return;

    // CART EMPTY 场景（以 itemCount 为准）
    if (!itemCount || itemCount === 0) {
      const currentRate = getRate(productPrice);
      const next = getNextTier(productPrice);

      if (currentRate > 0) {
        if (next) {
          const need = next.target - productPrice;
          elCurrent.innerHTML = `✅ You're already getting <strong>${currentRate * 100}% OFF</strong><br>🚀 Add Only <strong>${formatMoney(need)}</strong> More → Unlock <strong>${next.rate * 100}% OFF</strong>`;
          elNext.innerHTML = '';
        } else {
          elCurrent.innerHTML = `✅ You're already getting <strong>${currentRate * 100}% OFF</strong>`;
          elNext.innerHTML = '';
        }
      } else {
        const need = TIER_1 - productPrice;
        elCurrent.innerHTML = ''; // 保持你之前的做法，不强占首行
        elNext.innerHTML = `🚀 Add Only <strong>${formatMoney(need)}</strong> More → Unlock <strong>10% OFF</strong>`;
      }
      return;
    }

    // CART 有产品时，PDP 使用 cart 总价显示（保持一致）
    const rate = getRate(total);
    const next = getNextTier(total);

    elCurrent.innerHTML = `✅ Your cart total is <strong>${formatMoney(total)}</strong> — already getting <strong>${rate * 100}% OFF</strong><br>`;

    if (!next) {
      elNext.innerHTML = `🎉 You've unlocked the maximum discount available!`;
    } else {
      const need = next.target - total;
      const withThisProduct = total + productPrice;

      if (withThisProduct >= next.target) {
        elNext.innerHTML = `🚀 Add Only <strong>${formatMoney(need)}</strong> More → Unlock <strong>${next.rate * 100}% OFF</strong> Entire Order`;
      } else {
        if (need <= 5000) {
          elNext.innerHTML = `🚀 Almost there! Add Only <strong>${formatMoney(need)}</strong> More → Unlock <strong>${next.rate * 100}% OFF</strong>`;
        } else {
          elNext.innerHTML = `🚀 Add Only <strong>${formatMoney(need)}</strong> More → Unlock <strong>${next.rate * 100}% OFF</strong>`;
        }
      }
    }
  }

  // === Cart Drawer 渲染（只基于 cart.total_price & cart.item_count） ===
  // 文案： "✅ already getting X% OFF" + next 文案（单独渲染，方便样式独立调整）
  function renderCartDrawer(total, itemCount) {
    // 直接每次在 DOM 上查找，因为 drawer 容器可能是动态插入的
    const drawerEl = document.getElementById('cart-drawer-discount');
    if (!drawerEl) return;

    // 若购物车无商品，清空（你的需求里只在购物车有产品时显示）
    if (!itemCount || itemCount === 0) {
      drawerEl.innerHTML = '';
      return;
    }

    const rate = getRate(total);
    const next = getNextTier(total);

    let html = `✅ already getting <strong>${rate * 100}% OFF</strong>`;
    if (!next) {
      html += `<div>🎉 You've unlocked the maximum discount available!</div>`;
    } else {
      const need = next.target - total;
      if (need <= 5000) {
        html += `<div>🔥 Almost there! Spend <strong>${formatMoney(need)}</strong> more to unlock <strong>${next.rate * 100}% OFF</strong></div>`;
      } else {
        html += `<div>🚀 Add Only <strong>${formatMoney(need)}</strong> More → Unlock <strong>${next.rate * 100}% OFF</strong></div>`;
      }
    }

    drawerEl.innerHTML = html;
  }

  // MutationObserver：当 cart drawer DOM 在 cart:change 后稍后才插入页面（drawer 弹出时时常这样），监听短期内创建该节点并渲染
  function watchForDrawerAndRender(total, itemCount, timeout = 2000) {
    // 先尝试马上渲染一次（如果存在）
    renderCartDrawer(total, itemCount);
    // 如果已存在则不需要监听
    if (document.getElementById('cart-drawer-discount')) return;

    const observer = new MutationObserver((mutationList, obs) => {
      if (document.getElementById('cart-drawer-discount')) {
        renderCartDrawer(total, itemCount);
        obs.disconnect();
      }
    });

    observer.observe(document.documentElement || document.body, {
      childList: true,
      subtree: true
    });

    // 自动超时断开，避免长期监听
    setTimeout(() => observer.disconnect(), timeout);
  }

  // 主渲染（在收到 cart 数据时调用）
  function renderAll(total, itemCount) {
    // PDP 与 cart drawer 分离渲染
    renderPDP(total, itemCount);
    // cart drawer 只用 cart 值判断并显示（如果容器存在则立即写入，否则启动短期监听）
    if (document.getElementById('cart-drawer-discount')) {
      renderCartDrawer(total, itemCount);
    } else {
      // 监听短期内 drawer 的插入（保证加购后弹窗显示即时更新）
      watchForDrawerAndRender(total, itemCount, 2500);
    }
  }

  // 初始加载一次 cart，保证直接打开 PDP / Cart Page 时正确显示
  async function init() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();
      renderAll(cart.total_price || 0, cart.item_count || 0);
    } catch (e) {
      console.error('purchase-discount init /cart.js failed', e);
      // 兜底：购物车未知，PDP 以 productPrice 展示，cart drawer 清空
      renderAll(productPrice, 0);
    }
  }

  // 订阅主题的全局事件（product-form 会 dispatch cart:change）
  document.documentElement.addEventListener('cart:change', function (e) {
    const cart = e?.detail?.cart;
    if (cart && typeof cart.total_price !== 'undefined') {
      // 事件来了，立即渲染（会覆盖 PDP、并尽量更新 drawer）
      renderAll(cart.total_price, cart.item_count || 0);
    } else {
      // 若事件没有携带 cart，安全起见再 fetch 一次
      init();
    }
  });

  // 启动
  init();

})();

/*
 * -----------------------------------------------------------------------
 * 2026.1.22---form-drawer（包含shopify forms）---JS
 * -----------------------------------------------------------------------
 */
(function () {
  // 处理提交表单中的意向产品输入框自动填入和隐藏提交
  function initShopifyFormsPrefill() {
    const embed = document.querySelector('shopify-forms-embed');
    if (!embed || !embed.shadowRoot) return;

    const shadow = embed.shadowRoot;

    const input = shadow.querySelector('input[id="custom#intended_product"]');

    if (!input) return;

    // 1.自动填充产品名
    if (window.meta?.product?.handle) {
      input.value = window.meta.product.handle;
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }

    // 2.隐藏整个 field（包含 label）
    const fieldContainer = input.closest('div');
    if (fieldContainer) {
      fieldContainer.style.display = 'none';
    }

    // 3. mobile 下修正 app-router 样式
    overrideAppRouterStyle(shadow);

    // 4. 在 First Name 前插入 Delivery 文本
    insertDeliveryHeading(shadow);
  }

  // 处理移动端的Shopify forms 表单样式
  function overrideAppRouterStyle(shadow) {
    const appRouter = shadow.querySelector('[data-testid="app-router"]');
    if (!appRouter) return;

    const applyStyle = () => {
      if (window.innerWidth <= 490) {
        appRouter.style.justifyContent = 'unset';
      } else {
        appRouter.style.justifyContent = '';
      }
    };

    applyStyle();
    window.addEventListener('resize', applyStyle);
  }

  // 处理 First Name 前插入 Delivery 文本
  function insertDeliveryHeading(shadow) {
    // 防止重复插入
    if (shadow.querySelector('[data-custom="delivery-heading"]')) return;

    const firstNameInput = shadow.querySelector('input[id="custom#first_name"]');
    if (!firstNameInput) return;

    const firstNameField = firstNameInput.closest('div');
    if (!firstNameField) return;

    const heading = document.createElement('h2');
    heading.textContent = 'Delivery';
    heading.className = '_textHeading_2aowh_35';
    heading.setAttribute('data-custom', 'delivery-heading');
    heading.style.margin = '24px 0 8px';

    firstNameField.parentNode.insertBefore(heading, firstNameField);
  }

  // Shopify Forms 是异步加载的
  const observer = new MutationObserver(() => {
    initShopifyFormsPrefill();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();

/*
 * -----------------------------------------------------------------------
 * 2026.1.21---custom-jitter-tags---JS
 * -----------------------------------------------------------------------
 */
document.addEventListener('DOMContentLoaded', function() {
  const tag = document.querySelector('.custom-jitter-tags');
  if (tag) {
    function startRinging() {
      tag.style.animation = 'ring-bell 1s ease-in-out';
      setTimeout(() => {
        tag.style.animation = 'none';
      }, 1000);
    }

    const ringingInterval = setInterval(startRinging, 5000);

    const observerTag = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.removedNodes.forEach((node) => {
          if (node === tag) {
            clearInterval(ringingInterval);
            observerTag.disconnect();
          }
        });
      });
    });

    observerTag.observe(document.body, { childList: true, subtree: true });
  }
});

/*
 * -----------------------------------------------------------------------
 * 2025.6.12---product-des-position-nab---JS
 * -----------------------------------------------------------------------
 */
document.addEventListener("DOMContentLoaded", function () {
  // 检查组件是否存在（避免在非产品页执行）
  const productDesPositionNav = document.querySelector(
    ".product-des-position-nav"
  );
  if (!productDesPositionNav) return;

  // 初始化变量（作用域仅限当前闭包）
  const stickyTop = 0;
  const navHeight = productDesPositionNav.offsetHeight;
  const pcNavItems = document.querySelectorAll(".pc-nav .nav-item");
  const mobileNavDetails = document.getElementById("mobile-nav-details");
  const mobileCurrentSection = document.querySelector(".current-section");
  const mobileNavOptions = document.querySelectorAll(
    ".mobile-nav-options .nav-item"
  );

  // 通用：获取当前激活的模块ID
  function getCurrentActiveId() {
    const scrollY = window.scrollY + navHeight;
    let currentId = null;

    mobileNavOptions.forEach((option) => {
      const targetId = option.getAttribute("href").replace("#", "");
      const target = document.getElementById(targetId);
      if (!target) return;

      const targetTop = target.offsetTop;
      const targetBottom = targetTop + target.offsetHeight;
      if (scrollY >= targetTop && scrollY < targetBottom) {
        currentId = targetId;
      }
    });
    return currentId;
  }

  // 同步更新所有导航的active状态
  function updateActiveState() {
    const currentId = getCurrentActiveId();

    // 更新PC端导航active
    pcNavItems.forEach((item) => {
      const link = item.querySelector("a");
      const targetId = link.getAttribute("href").replace("#", "");
      item.classList.toggle("active", targetId === currentId);
    });

    // 更新移动端导航显示
    if (currentId) {
      const activeOption = [...mobileNavOptions].find(
        (opt) => opt.getAttribute("href") === `#${currentId}`
      );
      if (activeOption)
        mobileCurrentSection.textContent = activeOption.textContent;
    }
  }

  // 滚动处理函数（整合吸顶+active更新）
  function handleScroll() {
    // 吸顶状态
    const isSticky =
      productDesPositionNav.getBoundingClientRect().top <= stickyTop;
    productDesPositionNav.classList.toggle("product-nav-sticky", isSticky);

    // 实时更新active状态
    updateActiveState();
  }

  // 移动端选项点击处理（平滑滚动）
  mobileNavOptions.forEach((option) => {
    option.addEventListener("click", (e) => {
      e.preventDefault();
      const targetId = option.getAttribute("href");
      const target = document.querySelector(targetId);

      if (target) {
        const targetTop =
          target.getBoundingClientRect().top + window.scrollY - navHeight;
        window.scrollTo({ top: targetTop, behavior: "smooth" });
        mobileNavDetails.removeAttribute("open");
      }
    });
  });

  // 点击外部关闭下拉菜单
  document.addEventListener("click", (e) => {
    if (!mobileNavDetails) return;
    const isClickInside = mobileNavDetails.contains(e.target);
    if (!isClickInside && mobileNavDetails.hasAttribute("open")) {
      mobileNavDetails.removeAttribute("open");
    }
  });

  // 绑定事件（添加防抖）
  let scrollTimeout;
  window.addEventListener("scroll", () => {
    if (scrollTimeout) clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(handleScroll, 30);
  });
  window.addEventListener("resize", handleScroll);
  handleScroll(); // 初始加载执行一次
});

/*
 * -----------------------------------------------------------------------
 * 2025.4.7---guarantee-container---JS
 * -----------------------------------------------------------------------
 */
document.addEventListener("DOMContentLoaded", function () {
  var cards = [];
  var selectors = [
    ".card1",
    ".card2",
    ".card3",
    ".card4",
    ".card5",
    ".card6",
    ".card7",
  ];
  selectors.forEach(function (sel) {
    var el = document.querySelector(sel);
    if (el) cards.push(el);
  });

  function startNumberAnimation() {
    var numberElements = document.querySelectorAll(".card1-des-info-title");
    numberElements.forEach(function (el, index) {
      var finalValue = index === 0 ? "50" : "3";
      var interval = setInterval(function () {
        var rand = Math.floor(Math.random() * 100);
        el.innerText = rand;
      }, 50);
      setTimeout(function () {
        clearInterval(interval);
        el.innerText = finalValue;
      }, 3000);
    });
  }

  var container = document.querySelector(".guarantee-container");
  var observer = new IntersectionObserver(
    function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          cards.forEach(function (card, index) {
            setTimeout(function () {
              card.classList.add("animate");
            }, index * 100);
          });
          startNumberAnimation();
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.2 }
  );

  if (container) observer.observe(container);
});

/*
 * -----------------------------------------------------------------------
 * 2025.3.17---hiboost-region-selector---JS
 * -----------------------------------------------------------------------
 */
(function () {
  const SELECTOR = ".hiboost-region-selector";
  let activeDropdown = null;

  // 初始化单个组件
  function initRegionSelector(element) {
    const summary = element.querySelector("summary");
    if (!summary) return;

    const isTouchDevice =
      "ontouchstart" in window || navigator.maxTouchPoints > 0;

    // 统一关闭方法
    const closeDropdown = () => {
      element.removeAttribute("open");
      activeDropdown = null;
    };

    // 桌面端 hover 逻辑
    if (!isTouchDevice) {
      let hoverTimer;

      summary.addEventListener("mouseenter", () => {
        clearTimeout(hoverTimer);
        element.setAttribute("open", "");
        activeDropdown = element;
      });

      element.addEventListener("mouseleave", () => {
        hoverTimer = setTimeout(closeDropdown, 300);
      });

      element.addEventListener("mouseenter", () => {
        clearTimeout(hoverTimer);
      });
    }

    // 移动端点击逻辑
    if (isTouchDevice) {
      summary.addEventListener("click", (e) => {
        e.preventDefault();
        element.toggleAttribute("open");
        activeDropdown = element.open ? element : null;
      });
    }

    // 全局点击关闭
    document.addEventListener("click", (e) => {
      if (activeDropdown && !activeDropdown.contains(e.target)) {
        closeDropdown();
      }
    });

    // 窗口失焦关闭
    window.addEventListener("blur", closeDropdown);
  }

  // 自动初始化现有实例
  document.querySelectorAll(SELECTOR).forEach(initRegionSelector);

  // 动态加载监听
  new MutationObserver((mutations) => {
    mutations.forEach(({ addedNodes }) => {
      addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.matches(SELECTOR)) {
          initRegionSelector(node);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();

/*
 * -----------------------------------------------------------------------
 * 2024.12.31--- 产品描述的规格模块Tech Specs折叠效果JS
 * -----------------------------------------------------------------------
 */
function toggleCollapse(button) {
  const content = document.getElementById("tech-specs-list");
  const isExpanded = content.classList.toggle("expanded");

  const buttonText = button.querySelector(".reversed-link");
  const icon = button.querySelector(".circle-chevron");

  if (isExpanded) {
    buttonText.textContent = "View less";
    button.setAttribute("aria-expanded", "true");
  } else {
    buttonText.textContent = "View all";
    button.setAttribute("aria-expanded", "false");

    const target = document.getElementById("tech_specs_for_herf");
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}
window.toggleCollapse = toggleCollapse; // 将函数挂载到全局对象

/*
 * -----------------------------------------------------------------------
 * 2024.12.16---家用产品添加的文字，图片动画效果
 * -----------------------------------------------------------------------
 */
document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".section-box");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // 获取所有的 text-animation 元素
          const textElements = entry.target.querySelectorAll(".text-animation");
          const imgElements = entry.target.querySelectorAll(".img-animation");

          // 为每个 text-animation 元素动态添加延迟
          textElements.forEach((el, index) => {
            // 动态计算延迟时间，根据索引进行递增
            el.style.transitionDelay = `${index * 0.05}s`; // 每个元素间隔 0.2s
            el.classList.add("animate");
          });

          // 图片部分的动画，直接显示，不涉及延迟
          imgElements.forEach((el) => el.classList.add("animate"));
        } else {
          // 当元素离开视口时移除动画类
          const bounding = entry.boundingClientRect;
          if (bounding.top > 0) {
            const textElements =
              entry.target.querySelectorAll(".text-animation");
            const imgElements = entry.target.querySelectorAll(".img-animation");

            textElements.forEach((el) => el.classList.remove("animate"));
            imgElements.forEach((el) => el.classList.remove("animate"));
          }
        }
      });
    },
    { threshold: 0.2 } // 超过 20% 可见时触发
  );

  sections.forEach((section) => observer.observe(section));
});

/*
 * -----------------------------------------------------------------------
 * 2024.12.4---产品详情页模拟手机滑动模块的处理js
 * -----------------------------------------------------------------------
 */
let stickyOffsetTop, stickyHeight, phoneHeight, stepSize;
const images = document.querySelectorAll(".phone-content img");
const imageContent = document.getElementById("img-content");
const titles = document.querySelectorAll(".centerImg-title");
let ticking = false;
let lastIndex = -1;

// 实时获取 sticky-box 的位置
function getStickyBoxOffsetTop() {
  const stickyBox = document.getElementById("sticky-box");
  return stickyBox ? stickyBox.getBoundingClientRect().top + window.scrollY : 0;
}

// 初始化滚动相关的尺寸变量
function initializeDimensions() {
  const stickyBox = document.getElementById("sticky-box");
  const phoneModel = document.querySelector(".phone-frame");

  if (!stickyBox || !phoneModel || images.length === 0 || titles.length === 0) {
    return;
  }

  stickyOffsetTop = getStickyBoxOffsetTop();
  stickyHeight = stickyBox.offsetHeight;
  phoneHeight = phoneModel.offsetHeight;
  stepSize = (stickyHeight - phoneHeight) / images.length;

  // 使用 ResizeObserver 动态更新
  const observer = new ResizeObserver(() => {
    stickyOffsetTop = getStickyBoxOffsetTop();
    stickyHeight = stickyBox.offsetHeight;
    stepSize = (stickyHeight - phoneHeight) / images.length;
  });
  observer.observe(stickyBox);
}

// 更新左侧文案内容和过渡效果
function updateImageContent(text) {
  if (!imageContent) return;

  // 移除当前激活状态，触发淡出效果
  imageContent.classList.remove("active");

  // 等待动画完成后更新文本内容，并添加激活状态触发淡入效果
  setTimeout(() => {
    imageContent.textContent = text;
    imageContent.classList.add("active");
  }, 200); // 延时200ms以配合动画过渡
}

// 激活右侧小标题
function activateTitle(index) {
  titles.forEach((title, i) => {
    title.classList.toggle("active", i === index);
  });
}

// 处理滚动事件的逻辑
function handleScrollWithStep() {
  if (!stickyOffsetTop || !stickyHeight || !phoneHeight || !stepSize) return;

  const scrollY = window.scrollY;

  // 实时更新 stickyOffsetTop 避免内容偏移导致逻辑失效
  stickyOffsetTop = getStickyBoxOffsetTop();

  // 判断是否在 sticky-box 范围内
  if (scrollY < stickyOffsetTop || scrollY > stickyOffsetTop + stickyHeight) {
    return;
  }

  const scrollOffset = Math.max(
    0,
    Math.min(scrollY - stickyOffsetTop, stickyHeight - phoneHeight)
  );

  const currentIndex = Math.floor(scrollOffset / stepSize);

  if (currentIndex !== lastIndex) {
    images.forEach((img, index) => {
      img.classList.toggle("active", index === currentIndex);
    });

    const activeImage = images[currentIndex];
    if (activeImage && activeImage.dataset.text) {
      updateImageContent(activeImage.dataset.text);
    }

    activateTitle(currentIndex);
    lastIndex = currentIndex;
  }
}

// 右侧小标题交互功能
function addTitleInteractions() {
  titles.forEach((title, index) => {
    // 鼠标悬停激活
    title.addEventListener("mouseenter", () => {
      images.forEach((img, i) => img.classList.toggle("active", i === index));
      activateTitle(index);
      if (images[index] && images[index].dataset.text) {
        updateImageContent(images[index].dataset.text);
      }

      // 同步更新 lastIndex 确保滚动逻辑正常
      lastIndex = index;
    });
  });
}

// 滚动事件节流
function onScroll() {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      handleScrollWithStep();
      ticking = false;
    });
    ticking = true;
  }
}

// 初始化函数
function initialize() {
  initializeDimensions(); // 初始化滚动相关参数
  addTitleInteractions(); // 添加右侧交互功能
  window.addEventListener("scroll", onScroll); // 绑定滚动事件
  window.addEventListener("resize", initializeDimensions); // 绑定窗口大小变化事件

  // 等待所有资源加载完成后重新触发逻辑
  window.onload = () => {
    initializeDimensions();
    if (
      window.scrollY >= stickyOffsetTop &&
      window.scrollY <= stickyOffsetTop + stickyHeight
    ) {
      handleScrollWithStep(); // 如果在范围内，重新初始化状态
    }
  };
}

// 等待DOM内容加载完毕后初始化
document.addEventListener("DOMContentLoaded", initialize);
